import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../vass-core/services/common.service';
import { SignatureModel } from '../../models/signature.model';

@Injectable()
export class SignatureService {
  constructor(private commonService: CommonService) {}

  public getSignatureData(): Observable<SignatureModel> {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/sign/crm`;
    return this.commonService.getVerb(url);
  }
}
